
import {Component, Vue, Watch} from 'vue-property-decorator'
import {completeUserLoginInfo, getFigureCode, sendCode, sendEmailCode} from "@/apis/login/login";
import { getCollegeList } from '@/apis/myInfo/myInfo'
import { getSchoolList } from "@/apis/login/login"
import {getMobilexdomain} from '@/utils/utils';

@Component({
})
export default class Register extends Vue {
    private picCodeUrl = '';
    private sessionId = '';
    private mobilePhoneOrEmail = ''
    private shareClassFromCode:any=''
    private password = '';
    private passwordConfirm = ''
    private identType: 'teacher'| 'student' = 'teacher';
    private userName = '';
    // private selectedSchoolName = '';
    private code = '';
    private registerType: 'fast' | 'normal' = 'normal'
    private registMod: 'mobile'| 'email' = 'mobile' // 输入的账号的类型
    private stno :string = '';
    private teacherImg = require('@/assets/images/teacher.svg')
    private studentImg = require('@/assets/images/student.svg')
    private showSearchSchool = false // 搜索学校
    private searchText = '' // 搜索的学校名
    private schoolList: any = [] // 学校列表
    private isSchool: number = -1
    private index: number = -1
    private schoolName = ''
    private reqMap = new Map() // 记录是否已经请求过学校列表
    @Watch('showSearchSchool')
    onShowSearchSchool(newVal: boolean) {
      if (!this.reqMap.has('hasLoadList') && newVal) {
        this.getSchoolList()
        this.reqMap.set('hasLoadList', true)
      }
    }
    get selectedSchoolName() {
      const name = this.richtextFilter(this.schoolName)
      return name
    }
    goSearchSchool() {
      this.$router.push('/schoolSearch')
    }
    checkStno() {
      if (this.identType === 'student' && this.stno === '') {
        return false;
      }
      return true;
    }
    checkMobilePhoneOrEmail() {
      if (this.registerType === "fast") return true;
      let isMobilePhone = /1\d{10}/.test(this.mobilePhoneOrEmail);
      let isEmail = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.mobilePhoneOrEmail);
      if (isMobilePhone) {
        this.registMod = 'mobile'
      }
      if (isEmail) {
        this.registMod = 'email'
      }
      return ( isEmail || isMobilePhone)
    }

    /**
     * 检查密码强度
     * @param values 
     */
    checkPassword(values:any) {
      if(values == ""){
        return true;
      }
      if (this.registerType === "fast"){
        return true;
      }
      const regular = {
          password1: /^.{6,20}$/, // 6-20位
          password2: /^(?=.*[A-Za-z0-9].*)(?=.*[\W0-9_].*)(?=.*[A-Za-z\W_].*).{6,20}$/, // 字母数字标点符号至少两种
          password3: /^(?=.*[A-Za-z].*)(?=.*[\W_].*)(?=.*[0-9].*).{6,20}$/ // 字母数字符号
      }
      if (regular.password3.test(values)) {
        return true;
      } else if (regular.password2.test(values)) {
        return true;
      } else if (regular.password1.test(values)) {
        return false;
      } else {
        return false;
      }
    }

    checkPasswordConfirm(value:any) {
      if (this.passwordConfirm === '') {
        return true
      }
      return this.password === this.passwordConfirm
      // return true
    }
    sendCode() {
      let currentLocation:string = window.localStorage.getItem('currentLocation') || '';
      let mobilexdomain = getMobilexdomain();
      if (this.registerType === "normal") {
          if (this.registMod === 'mobile') {
            // 发送短信验证码
            sendCode(this.code, this.mobilePhoneOrEmail, this.sessionId,mobilexdomain).then(res => {
              const registerUserInfo = {
                type: this.identType,
                email: this.mobilePhoneOrEmail,
                password: this.password,
                username: this.userName,
                school: this.selectedSchoolName,
                stno: this.identType === 'student' ?this.stno : '',
              }
              let query = encodeURIComponent(this.mobilePhoneOrEmail);
              window.sessionStorage.setItem('registerUserInfoCache', JSON.stringify(registerUserInfo));
              this.$router.push({
                path: '/loginVerify',
                // query: {
                //   userCount: query,
                // }
              });
            }).catch(e => {
              this.getPicCode();
            })
          } else if (this.registMod === 'email') { // 发送邮箱验证码
            sendEmailCode(this.code, this.mobilePhoneOrEmail, this.sessionId).then(res => {
              const registerUserInfo = {
                type: this.identType,
                email: this.mobilePhoneOrEmail,
                password: this.password,
                username: this.userName,
                school: this.selectedSchoolName,
                stno: this.identType === 'student' ?this.stno : '',
              }
              let query = encodeURIComponent(this.mobilePhoneOrEmail);
              window.sessionStorage.setItem('registerUserInfoCache', JSON.stringify(registerUserInfo));
              this.$router.push({
                path: '/loginVerify',
                // query: {
                //   userCount: query,
                // }
              });
            }).catch(e => {
              this.getPicCode();
            })
          }
      } else if (this.registerType === "fast") {
        // 补全用户信息
        console.log(window.localStorage.getItem('token_for_login'))
        console.log()
        
        completeUserLoginInfo(
          this.userName,
          this.selectedSchoolName,
          this.identType === 'teacher' ? '1' : '0',
          window.localStorage.getItem('token_for_login'),
          this.code,
          this.sessionId,
          this.identType === 'student' ? this.stno : ''
      ).then(res => {
          window.localStorage.setItem('token', localStorage.getItem('token_for_login') as string);
          this.$store.dispatch('setUserInfo').then(() => {
            if(currentLocation.indexOf("ShareClass")>=0){
                window.localStorage.removeItem('currentLocation');
                
                this.$router.push({ path: '/joinCourses' ,query: {
                  code:this.shareClassFromCode
                }});
                //window.localStorage.setItem('token', res.token);
                return 
            }
            if(currentLocation.indexOf("courseHome?courseId=")>=0 || currentLocation.indexOf("joinCourse?code=")>=0){
                window.localStorage.removeItem('currentLocation');
                window.location.href = currentLocation;
                return
            }
            this.$router.push('/')
            window.dispatchEvent(new CustomEvent('onLoginSucceed'))
          });
        })
      }
    }
    getPicCode() {
      getFigureCode().then(res => {
        this.sessionId = res.sessionid
        this.picCodeUrl = res.url
      })
    }
    activated() {
      // if (window.sessionStorage.getItem('selectedSchoolName')) {
      //   this.selectedSchoolName = window.sessionStorage.getItem('selectedSchoolName') || '';
      //   window.sessionStorage.removeItem('selectedSchoolName');
      // }
      this.getPicCode();
    }
    created() {
      this.$router.onReady(() => {
        if (this.$route.query.userCount) {
          this.mobilePhoneOrEmail = this.$route.query.userCount as string;
          this.registerType = "fast";
        } else {
          this.registerType = "normal";
        }
        if(this.$route.query.shareClass){
           this.shareClassFromCode=this.$route.query.shareClass
        }
      })
    }
    onCancelSearch() {
      this.searchText = ''
      this.getSchoolList()
    }
    inputText() {
      this.getSchoolList()
    }
    confimSchool() {
      this.showSearchSchool = false
      if (this.schoolList.length === 0) {
        this.schoolName = this.searchText
      }
    }
    getSchoolList() {
      getSchoolList(this.searchText).then(res => {
        this.schoolList = res
      })
    }
    chooseSchoole(schoolName: string) {
      this.schoolName = schoolName
      // this.index = index
      // this.selectedSchoolName = this.schoolList[index].name
      // this.isSchool = index
    }
    // 过滤html标签
    richtextFilter(str: string): string {
      if (!str) {
        return ''
      }
      let text = str
      // 去除html标签, 图片, 换行, 回车等等
      text = text.replace(/(\n)/g, '')
      text = text.replace(/(\t)/g, '')
      text = text.replace(/(\r)/g, '')
      text = text.replace(/<\/?[^>]*>/g, '')
      text = text.replace(/\s*/g, '')
      return text
    }
  }
